/**
 * Affiliations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import {store} from "../../store";

// States
const state = {
    categoriePrestations: [],
    categoriePrestation: {}
};

// Getters
const getters = {
    categoriePrestations: state => {
        return state.categoriePrestations
    },

    categoriePrestation: state => {
        return state.categoriePrestation
    }
};

// Actions
const actions = {
    getCategoriePrestations(context, payload) {
        function successCallback(response) {
            context.commit('getCategoriePrestationsHandler', { categoriePrestations: response.data.categories });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CategoriePrestation.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getCategoriePrestation(context, payload) {
        function successCallback(response) {
            context.commit('getCategoriePrestationHandler', { categoriePrestation: response.data.categorie });
        }

        function errorCallback(error) {

            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CategoriePrestation.Get, localToken, successCallback, errorCallback, payload.errorMessages);

    },

    createCategoriePrestation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'categorie-prestation', params: { categorie: response.data.categorie.slug } });
        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CategoriePrestation.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateCategoriePrestation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'categorie-prestation' });
            router.push({ name: 'categorie-prestation', params: { categorie: response.data.categorie.slug } });

        }

        function errorCallback(error) {
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CategoriePrestation.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteCategoriePrestation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            store.dispatch('findAndRemove', {name: 'categorie-prestation' });
            router.push({ name: 'categorie-prestations' });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.CategoriePrestation.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    getCategoriePrestationsHandler(state, { categoriePrestations }) {
        // Update affiliations state
        state.categoriePrestations = categoriePrestations;
    },

    getCategoriePrestationHandler(state, { categoriePrestation }) {
        // Update affiliation state
        state.categoriePrestation = categoriePrestation;
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}